/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Offices from './Offices/index'
import React from 'react'
import SearchTermInput from './SearchTermInput/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/Search/Content/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={0}
 onDismiss={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SearchTermInput
  viewPath={`${viewPath}/SearchTermInput`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
</div>
<Offices
  viewPath={`${viewPath}/Offices`}
/>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}